var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g, _path36, _g2, _path37, _g3, _path38, _g4, _path39, _g5, _path40, _path41, _path42, _path43, _path44, _path45;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVibLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 186,
    viewBox: "0 0 219 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2746 159.928H33.3917C36.9957 159.928 39.512 157.898 39.512 154.976C39.512 153.099 38.4954 151.576 36.8188 150.839C38.1892 150.053 38.9786 148.63 38.9786 146.93C38.9786 144.01 36.6419 142.155 32.9323 142.155H24.2746V159.928ZM29.3018 156.119V152.793H32.3989C33.6187 152.793 34.3052 153.402 34.3052 154.445C34.3052 155.509 33.6187 156.119 32.3989 156.119H29.3018ZM29.3018 149.137V145.94H31.9685C33.162 145.94 33.822 146.523 33.822 147.537C33.822 148.58 33.162 149.137 31.9685 149.137H29.3018Z",
    fill: "#3f2a08"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3635 159.928H46.4936V154.875H48.4237L50.9611 159.928H56.7777L53.5011 153.936C55.381 152.896 56.4477 151.016 56.4477 148.53C56.4477 144.594 53.781 142.155 49.464 142.155H41.3635V159.928ZM46.3907 150.789V146.344H48.7775C50.404 146.344 51.2911 147.133 51.2911 148.553C51.2911 149.976 50.404 150.789 48.7775 150.789H46.3907Z",
    fill: "#3f2a08"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.884 159.928H64.0142V142.155H58.884V159.928Z",
    fill: "#3f2a08"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3132 160.308C80.2137 160.308 83.9207 157.338 84.6838 152.819H79.477C78.8434 154.495 77.3436 155.562 75.4136 155.562C72.9264 155.562 71.1996 153.708 71.1996 151.042C71.1996 148.35 72.9501 146.523 75.4664 146.523C77.3199 146.523 78.8671 147.563 79.4005 149.163H84.5808C83.6673 144.67 80.0104 141.775 75.2631 141.775C69.7764 141.775 65.9928 145.557 65.9928 151.042C65.9928 156.525 69.7764 160.308 75.3132 160.308Z",
    fill: "#3f2a08"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6121 159.928H91.7423V153.199H93.976L97.3794 159.928H103.32L98.6494 151.296C99.1827 150.66 99.6633 149.823 100.07 148.783L102.713 142.155H97.1497L95.5496 146.6C95.0163 148.147 94.4328 148.53 92.6057 148.53H91.7423V142.155H86.6121V159.928Z",
    fill: "#3f2a08"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.765 159.928H125.895V142.155H120.765V148.53H115.281V142.155H110.15V159.928H115.281V153.249H120.765V159.928Z",
    fill: "#3f2a08"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.547 160.308C143.211 160.308 147.224 156.475 147.224 151.042C147.224 145.607 143.211 141.775 137.547 141.775C131.887 141.775 127.873 145.607 127.873 151.042C127.873 156.475 131.887 160.308 137.547 160.308ZM133.08 151.042C133.08 148.376 134.934 146.523 137.547 146.523C140.19 146.523 142.018 148.376 142.018 151.042C142.018 153.708 140.19 155.562 137.547 155.562C134.934 155.562 133.08 153.708 133.08 151.042Z",
    fill: "#3f2a08"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M156.873 160.308C161.673 160.308 164.643 157.388 164.643 152.616V142.155H159.539V152.286C159.539 154.392 158.65 155.509 156.873 155.509C155.093 155.509 154.206 154.392 154.206 152.286V142.155H149.076V152.616C149.076 157.388 152.073 160.308 156.873 160.308Z",
    fill: "#3f2a08"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M173.885 160.308C178.302 160.308 180.919 158.228 180.919 154.722C180.919 151.779 179.015 150.053 174.698 149.086C172.412 148.58 171.575 148.02 171.575 147.107C171.575 146.244 172.335 145.71 173.529 145.71C174.952 145.71 175.765 146.447 175.765 147.793H180.589C180.589 144.137 177.795 141.775 173.428 141.775C169.238 141.775 166.648 143.857 166.648 147.207C166.648 150.203 168.602 152.056 172.615 152.819C174.772 153.249 175.815 153.912 175.815 154.925C175.815 155.815 175.052 156.322 173.808 156.322C172.335 156.322 171.472 155.535 171.472 154.165H166.521C166.521 157.998 169.262 160.308 173.885 160.308Z",
    fill: "#3f2a08"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M182.975 159.928H195.443V155.738H188.052V152.996H194.479V148.883H188.052V146.294H195.163V142.155H182.975V159.928Z",
    fill: "#3f2a08"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3406 31.0254H77.418L84.0981 13.2527H78.6378L76.5546 19.118L74.9044 23.74L73.2542 19.118L71.171 13.2527H65.6606L72.3406 31.0254Z",
    fill: "#3f2a08"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3406 31.0254H97.8083V26.8363H90.418V24.0937H96.8446V19.9811H90.418V17.3917H97.5284V13.2527H85.3406V31.0254Z",
    fill: "#3f2a08"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.068 31.0254H105.145V21.9609L111.902 31.0254H116.066V13.2527H111.012V22.2671L104.258 13.2527H100.068V31.0254Z",
    fill: "#3f2a08"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M119.087 31.0254H128.204C131.808 31.0254 134.324 28.9955 134.324 26.0734C134.324 24.1967 133.308 22.6736 131.631 21.9371C133.001 21.1505 133.791 19.7277 133.791 18.0278C133.791 15.1084 131.454 13.2527 127.744 13.2527H119.087V31.0254ZM124.114 27.2164V23.8905H127.211C128.431 23.8905 129.117 24.5002 129.117 25.5429C129.117 26.6067 128.431 27.2164 127.211 27.2164H124.114ZM124.114 20.2345V17.0379H126.781C127.974 17.0379 128.634 17.6213 128.634 18.6349C128.634 19.6776 127.974 20.2345 126.781 20.2345H124.114Z",
    fill: "#3f2a08"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M134.422 31.0254H139.856L140.823 28.5125H146.893L147.856 31.0254H153.317L146.41 13.2527H141.329L134.422 31.0254ZM141.889 24.7536L143.869 19.2447L145.85 24.7536H141.889Z",
    fill: "#3f2a08"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M60.436 136.662H61.9225V128.4H60.436V136.662Z",
    fill: "#df5a04"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7903 128.4V134.178L70.3156 128.4H68.8423V136.662H70.2707V130.857L73.7322 136.662H75.2161V128.4H73.7903Z",
    fill: "#df5a04"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7794 136.662H85.2659V129.728H87.8508V128.4H81.1892V129.728H83.7794V136.662Z",
    fill: "#df5a04"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8297 136.662H99.3269V135.258H95.3162V133.212H99.0523V131.85H95.3162V129.762H99.3269V128.4H93.8297V136.662Z",
    fill: "#df5a04"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M105.902 136.662H107.389V133.13H108.382L110.417 136.662H112.12L109.821 132.985C110.755 132.663 111.434 131.874 111.434 130.834C111.434 129.284 110.119 128.4 108.574 128.4H105.902V136.662ZM107.399 131.921V129.728H108.588C109.435 129.728 109.966 130.171 109.966 130.857C109.966 131.475 109.499 131.884 108.709 131.921H107.399Z",
    fill: "#df5a04"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M118.11 136.662H123.126V135.258H119.596V128.4H118.11V136.662Z",
    fill: "#df5a04"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M132.521 136.778C135.254 136.778 136.511 134.78 136.511 132.528C136.511 130.277 135.254 128.279 132.521 128.279C129.791 128.279 128.535 130.277 128.535 132.528C128.535 134.78 129.791 136.778 132.521 136.778ZM132.521 135.464C130.75 135.464 130.1 134.088 130.1 132.528C130.1 130.974 130.75 129.598 132.521 129.598C134.293 129.598 134.943 130.974 134.943 132.528C134.943 134.088 134.293 135.464 132.521 135.464Z",
    fill: "#df5a04"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M146.262 136.778C147.904 136.778 149.219 135.944 149.874 134.4L148.501 133.838C148.058 134.949 147.326 135.371 146.262 135.371C144.488 135.371 143.735 134.112 143.735 132.47C143.735 130.939 144.488 129.68 146.238 129.68C147.313 129.68 148.168 130.103 148.477 131.19L149.864 130.641C149.196 129.097 147.886 128.265 146.249 128.265C143.529 128.265 142.262 130.266 142.262 132.528C142.262 134.796 143.543 136.778 146.262 136.778Z",
    fill: "#df5a04"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M156.012 136.662H157.498V134.516L159.175 132.779L161.725 136.662H163.574L160.205 131.787L163.51 128.4H161.522L157.498 132.71V128.4H156.012V136.662Z",
    fill: "#df5a04"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6962 171.336C61.6962 169.747 60.3443 168.454 58.6783 168.454C57.0228 168.454 55.6736 169.747 55.6736 171.336C55.6736 172.925 57.0228 174.224 58.6783 174.224H58.7258L57.0756 176.832H58.7733L61.2103 172.904C61.5219 172.453 61.6962 171.914 61.6962 171.336ZM57.1231 171.336C57.1231 170.513 57.8201 169.829 58.6783 169.829C59.5548 169.829 60.2466 170.513 60.2466 171.336C60.2466 172.16 59.5548 172.844 58.6783 172.844C57.8201 172.844 57.1231 172.16 57.1231 171.336Z",
    fill: "#df5a04"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4889 176.948C72.7042 176.948 73.2666 174.763 73.2666 172.709C73.2666 170.653 72.6804 168.435 70.4071 168.435C67.904 168.435 67.6162 170.938 67.6162 172.698C67.6162 174.446 67.9278 176.948 70.4889 176.948ZM70.4546 175.552C69.1133 175.552 69.0737 174.021 69.0737 172.698C69.0737 171.371 69.1133 169.863 70.4071 169.863C71.6982 169.863 71.7352 171.36 71.7352 172.688C71.7352 173.984 71.7114 175.552 70.4546 175.552Z",
    fill: "#df5a04"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1214 173.541V168.57H82.8778L78.8408 174.031V174.892H82.6613V176.832H84.1214V174.892H85.439V173.541H84.1214ZM80.7418 173.541L82.6613 170.84V173.541H80.7418Z",
    fill: "#df5a04"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4238 175.494C94.6568 174.757 96.4813 172.823 96.4813 171.028C96.4813 169.373 95.3486 168.459 93.8278 168.459C92.0033 168.459 90.9498 169.945 90.9498 171.482L92.3993 171.577C92.4337 170.729 92.7558 169.792 93.8383 169.792C94.6515 169.792 94.9974 170.331 94.9974 170.991C94.9974 172.978 92.4469 174.786 90.9841 175.658V176.832H96.8906V175.494H93.4238Z",
    fill: "#df5a04"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M107.6 173.541V168.57H106.357L102.32 174.031V174.892H106.14V176.832H107.6V174.892H108.918V173.541H107.6ZM104.221 173.541L106.14 170.84V173.541H104.221Z",
    fill: "#df5a04"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M117.544 171.154C117.124 171.154 116.715 171.236 116.264 171.476L116.562 169.932H119.984V168.57H115.387L114.587 172.915L115.926 173.253C116.224 172.775 116.792 172.487 117.33 172.487C118.299 172.487 118.848 173.189 118.848 174.008C118.848 174.81 118.223 175.61 117.33 175.61C116.324 175.61 115.878 174.81 115.72 174.055L114.347 174.435C114.645 175.826 115.844 176.948 117.33 176.948C118.978 176.948 120.359 175.586 120.359 174.021C120.359 172.448 119.089 171.154 117.544 171.154Z",
    fill: "#df5a04"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M129.056 176.948C130.67 176.948 132.122 176.077 132.122 174.401C132.122 173.506 131.699 172.709 130.601 172.413C131.414 172.033 131.676 171.36 131.676 170.711C131.676 169.291 130.408 168.448 129.033 168.448C127.607 168.448 126.384 169.349 126.384 170.903L127.786 171.004C127.8 170.272 128.301 169.829 129.056 169.829C129.724 169.829 130.25 170.172 130.25 170.893C130.25 171.529 130.073 171.943 128.682 171.943V173.073C129.619 173.073 130.707 173.107 130.707 174.282C130.707 175.166 129.928 175.586 129.08 175.586C128.122 175.586 127.401 175.061 127.401 174.137L125.986 174.224C125.986 176.053 127.414 176.948 129.056 176.948Z",
    fill: "#df5a04"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M141.023 171.154C140.603 171.154 140.194 171.236 139.742 171.476L140.041 169.932H143.463V168.57H138.866L138.066 172.915L139.404 173.253C139.703 172.775 140.27 172.487 140.809 172.487C141.778 172.487 142.327 173.189 142.327 174.008C142.327 174.81 141.701 175.61 140.809 175.61C139.803 175.61 139.357 174.81 139.198 174.055L137.825 174.435C138.124 175.826 139.323 176.948 140.809 176.948C142.457 176.948 143.838 175.586 143.838 174.021C143.838 172.448 142.568 171.154 141.023 171.154Z",
    fill: "#df5a04"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M152.535 176.948C154.148 176.948 155.601 176.077 155.601 174.401C155.601 173.506 155.178 172.709 154.08 172.413C154.893 172.033 155.154 171.36 155.154 170.711C155.154 169.291 153.887 168.448 152.511 168.448C151.086 168.448 149.863 169.349 149.863 170.903L151.265 171.004C151.278 170.272 151.78 169.829 152.535 169.829C153.203 169.829 153.729 170.172 153.729 170.893C153.729 171.529 153.552 171.943 152.16 171.943V173.073C153.098 173.073 154.185 173.107 154.185 174.282C154.185 175.166 153.407 175.586 152.559 175.586C151.601 175.586 150.88 175.061 150.88 174.137L149.465 174.224C149.465 176.053 150.893 176.948 152.535 176.948Z",
    fill: "#df5a04"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M164.404 176.948C166.619 176.948 167.182 174.763 167.182 172.709C167.182 170.653 166.595 168.435 164.322 168.435C161.819 168.435 161.531 170.938 161.531 172.698C161.531 174.446 161.843 176.948 164.404 176.948ZM164.37 175.552C163.028 175.552 162.989 174.021 162.989 172.698C162.989 171.371 163.028 169.863 164.322 169.863C165.613 169.863 165.65 171.36 165.65 172.688C165.65 173.984 165.626 175.552 164.37 175.552Z",
    fill: "#df5a04"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15_517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 38,
    width: 95,
    height: 54
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6578 38.0083H156.186V91.902H62.6578V38.0083Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15_517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.497 37.9739L156.318 84.6323L149.388 91.5402L109.497 51.7739L69.6072 91.5402L62.6789 84.6323L109.497 37.9739Z",
    fill: "#3f2a08"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_15_517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 110,
    width: 12,
    height: 11
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9444 110.147H79.0833V120.898H68.9444V110.147Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_15_517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6072 110.807H78.6345V121.141H69.6072V110.807Z",
    fill: "#df5a04"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_15_517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 110,
    width: 22,
    height: 11
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1111 110.147H102.741V120.898H81.1111V110.147Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_15_517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.4808 110.807H102.213V121.141H81.4808V110.807Z",
    fill: "#3f2a08"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_15_517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 110,
    width: 23,
    height: 11
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M104.769 110.147H126.398V120.898H104.769V110.147Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_15_517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.077 110.807H125.809V121.141H105.077V110.807Z",
    fill: "#df5a04"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_15_517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 128,
    y: 110,
    width: 23,
    height: 11
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M128.426 110.147H150.056V120.898H128.426V110.147Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_15_517)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.656 110.807H149.388V121.141H128.656V110.807Z",
    fill: "#3f2a08"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.6072 97.7197H90.3391V108.054H69.6072V97.7197Z",
    fill: "#3f2a08"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1854 97.7197H113.917V108.054H93.1854V97.7197Z",
    fill: "#df5a04"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.782 97.7197H137.514V108.054H116.782V97.7197Z",
    fill: "#3f2a08"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.36 97.7197H149.388V108.054H140.36V97.7197Z",
    fill: "#df5a04"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.188 88.4704H98.6165V79.2765H108.188V88.4704ZM120.378 79.2765V88.4704H110.81V79.2765H120.378ZM108.188 76.6738H98.6535C99.1024 71.5819 103.129 67.4641 108.188 66.8649V76.6738ZM110.81 66.8438C115.866 67.4641 119.892 71.5634 120.341 76.6553H110.81V66.8438Z",
    fill: "#3f2a08"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.497 57.745L143.452 87.7392L109.497 53.8884L75.5426 87.7392L109.497 57.745Z",
    fill: "#df5a04"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVibLogo);
export default __webpack_public_path__ + "static/media/VIB Logo.571dc62f191d244c39a4a31d9c0bf5f8.svg";
export { ForwardRef as ReactComponent };